<button class="button-icon" mat-mini-fab (click)="handleOnClick()" [ngStyle]="{ color: color }">
	<mat-icon>{{ iconName }}</mat-icon>
</button>
